<template>
  <div class="recruitment-page">

    <header-cmp></header-cmp>

    <!-- banner图 开始-->
    <section class="page-part banner banner_recruitment"></section>
    <!-- banner图 结束-->

    <section class="page-part content">
      <div class="page-inner">
        <div class="section-selection">
          <ul>
            <li class="selection-item" :class="current=='合伙人'?'active':''" @click="current='合伙人'">合伙人</li>
            <li class="selection-item" :class="current=='总经办'?'active':''" @click="current='总经办'">总经办</li>
            <li class="selection-item" :class="current=='市场部'?'active':''" @click="current='市场部'">市场部</li>
            <li class="selection-item" :class="current=='运营部'?'active':''" @click="current='运营部'">运营部</li>
            <li class="selection-item" :class="current=='财务部'?'active':''" @click="current='财务部'">财务部</li>
            <li class="selection-item" :class="current=='技术部'?'active':''" @click="current='技术部'">技术部</li>
          </ul>

        </div>

        <section class="no-content" v-if="!chosedGangweis">
          <h1>该部门暂无招聘信息</h1>
        </section>

        <!-- 可展开面板 -->
        <section class="section-content" v-for="(item, index) in chosedGangweis" :key="index">
          <div class="section-content-header" :class="item.isExtend?'active':''" @click="item.isExtend = !item.isExtend">
            <i class="icon icon-dropdown"></i>
            <h3 class="title">{{ item.gangwei }}</h3>
            <span class="address">杭州</span>
            <!-- <span class="date">2017-12-12</span> -->
          </div>



          <section class="section-content-detail" v-show="item.isExtend">
            <h3 class="detail-title" v-show="item.zhize.length > 0">岗位职责</h3>
            <p class="detail-item" v-for="(text, i) in item.zhize" :key="i">{{ text }}</p>

            <h3 class="detail-title" v-show="item.yaoqiu.length > 0">岗位要求</h3>
            <p class="detail-item" v-for="(text, i) in item.yaoqiu" :key="i">{{ text }}</p>
          </section>
        </section>

        <!-- 可展开面板 -->


      </div>
    </section>

    <footer-cmp></footer-cmp>
  </div>
</template>

<script type="text/ecmascript-6">
  import HeaderCmp from '@/components/header';
  import FooterCmp from '@/components/footer';

  export default {

    name: 'recruitmentPage',
    data() {
      return {
        current: '市场部',
        recruitmentData: [{
            bumen: '运营部',
            gangweis: [{
              gangwei: '物流专员',
              zhize: [
                '1、时刻监控后台新订单，及时把订单进行发布；',
                '2、如果系统不能智能识别订单，需要电话与货主确认发货仓库和到达仓库、吨位和货物类型和注意事项；',
                '3、如果系统没有司机抢单，需要电话寻找目标司机，告知司机货物信息及谈价格；',
                '4、新司机信息的系统录入和新货主的系统录入；', '5、写成交记录和用系统生成账单和结算；'
              ],
              yaoqiu: [
                '1.熟练WORD,EXCEL,POWERPOINT计算机办公软件。',
                '2.优秀的沟通能力，富有开拓创新意识，具吃苦耐劳的精神。',
                '3.思维敏捷、性格开朗、有团队协作精神。',
                '4.实事求是，有强烈的责任心，能够在压力下完成任务。', '5.富有工作激情和热情，学习能力强。'
              ]
            }, {
              gangwei: '储备干部',
              zhize: [
                '1、定期完成量化的工作要求，并能独立处理和解决所负责的任务；',
                '2、能够适应各种工作岗位、环境和压力，需要在公司内部各岗位进行轮岗；'
              ],
              yaoqiu: [
                '1.熟练WORD,EXCEL,POWERPOINT计算机办公软件。',
                '2.优秀的沟通能力，富有开拓创新意识，具吃苦耐劳的精神。',
                '3.实事求是，有强烈的责任心，能够在压力下完成任务。',
                '4.富有工作激情和热情，学习能力强。',
                '5.具有高效执行与不断学习的能力和创新能力。',
                '6．服从公司调配安排。'
              ]
            }, {
              gangwei: '新媒体运营',
              zhize: [
                '1．负责用户和产品的运营推广内容完善；'
              ],
              yaoqiu: [
                '1.本科学历',
                '2.一年以上产品及运营和社区运营工作经验，企业类、设计类、营销类产品为佳；',
                '3.有很强的语言表达能力和沟通能力及写作能力，创新能力。',
                '4.有数据分析能力，逻辑性强。',
                '5.喜欢互联网创业，及时发布新闻，能适应高强度要求。',
                '6.有良好的亲和力和团队合作精神，并有极强的事业心和责任心'
              ]
            }]
          },
          {
            bumen: '市场部',
            gangweis: [{
              gangwei: '市场专员',
              zhize: [
                '1.独立开发大宗电商及贸易商客户。',
                '2.根据交易员情况，综合考虑外部市场信息和内部资源、客户需求等因素，拜访及拓展用户；',
                '3.协助运营部做好线下营销活动的组织落实。',
                '4.及时反馈市场情况，根据公司战略完成季度及年度的市场拓展计划',
                '5.积极完成公司设定的市场考核',
                '6.可以外派'
              ],
              yaoqiu: []
            }, {
              gangwei: '货车新车销售',
              zhize: [
                '1.对大型货车的销售具有一定的经验。',
                '2.根据平台进行电话及微营销销售。',
                '3.与4S店及汽车厂家沟通及时上传更新平台车辆信息。',
                '4.配合运营人员完成车辆的活动运营。'
              ],
              yaoqiu: []
            }]
          }
        ].map(item => {
          item.gangweis.forEach(i => i.isExtend = false );
          return item;
        })
      }
    },
    computed: {
      chosedGangweis() {
        let chosedItem = this.recruitmentData.filter(item => item.bumen == this.current)[0];
        let chosedGangweis = chosedItem && chosedItem.gangweis;
        return chosedGangweis;
      }
    },
    components: {
      HeaderCmp,
      FooterCmp
    },
    mounted() {
      this.$utils.watchRouteGoAnchor(this);
    },
    // watch: {
    //   '$route' () {
    //     this.$utils.watchRouteGoAnchor(this);
    //   }
    // }
  }

</script>

<style rel="stylesheet/scss" lang="scss">
  @import "../style/_variable";
  .recruitment-page {
    width: 100%; // banner图
    .banner {
      height: 500px;
      &_recruitment {
        background: url("../assets/images/page_recruitment/banner4.png") center no-repeat;
         background-size:100% 100%;
         -moz-background-size:100% 100%;
      }
    }
    .content {
      padding: 90px 0;

      .selection-item {
        background-color: $bg-clr_lighter;
        width: 180px;
        height: 60px;
        display: inline-block;
        text-align: center;
        line-height: 60px;
        margin-right: -3px;
        cursor: pointer;
        transition: all .5s;

        &:last-child {
          margin-right: none;
        }
        &.active {
          color: white;
          background-color: $text-clr_primary;
        }
      }

      .section-content {
        margin-top: 60px;
        &-header {
          cursor: pointer;
          user-select: none;
          border-bottom: 2px solid $border-clr;
          padding: 12px 0;
          .title {
            display: inline-block;
            font-size: 16px;
            font-weight: bold;
            margin: 0 763px 0 20px;
          }
          .address,
          .date {
            float: right;
            color: $text-clr_light;
          }
          .address {
            margin-right: 50px;
          }

          &.active {
            .title {
              color: $text-clr_primary;
            }
            .icon-dropdown:before {
              transform: rotate3d(0,0,1, 0deg);
            }
          }
        }

        &-detail {
          padding: 0 50px;
          color: $text-clr_light;
          line-height: 25px;
          .detail-title {
            margin: 20px 0;
          }
          .detail-item {
            color: $text-clr_light;
          }
        }


      }
      .no-content {
        text-align: center;
        padding: 50px 0;
        h1 {
          color: $text-clr_light;
        }
      }
    }

    .icon {
      &-dropdown:before {
        width: 18px;
        height: 18px;
        margin-left: 10px;
        transform: rotate3d(0,0,1, -90deg);
        background-image: url('../assets/images/page_recruitment/dropdown.png');
        transition: all .5s;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/recruitment.vue